import { render, staticRenderFns } from "./bulkUpdateOffersPremium.vue?vue&type=template&id=0552a8a6&scoped=true&"
import script from "./bulkUpdateOffersPremium.vue?vue&type=script&lang=js&"
export * from "./bulkUpdateOffersPremium.vue?vue&type=script&lang=js&"
import style0 from "./bulkUpdateOffersPremium.vue?vue&type=style&index=0&id=0552a8a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0552a8a6",
  null
  
)

export default component.exports